import { render, staticRenderFns } from "./CadastroConfiguracaoFreteCeps.vue?vue&type=template&id=00d2c112"
import script from "./CadastroConfiguracaoFreteCeps.vue?vue&type=script&lang=js"
export * from "./CadastroConfiguracaoFreteCeps.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports